/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const BlackListBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="default" sx={{ ml: 1 }} {...props}>
      Blacklist
    </Badge>
  );
};

export default BlackListBadge;
